import React, {Component} from 'react';
import {Helmet} from 'react-helmet'
import {connect} from "react-redux";
import {withTranslate} from "react-redux-multilingual";
import HomeHero from "./home/home-hero";
import {Amenities, CommissionStatement, Projects} from "./home/home-sections";
import CounterBlock from "./common/countup/countup";
import OurServicesSection from "./sections/ourservices/ourservices";
import NeighborhoodsSection from "./sections/neighborhoods/neighborhoods";
import OurPartners from "./sections/ourpartners/ourpartners";
import GallerrySection from "./sections/gallerry/gallerry";
import './home/home.scss';

class Home1 extends Component {
    render() {
        return (
            <div className="cpr-home">
                <Helmet>
                    <title>City Premium Realty</title>
                </Helmet>

                <HomeHero/>
                <CommissionStatement/>
                <Projects figures={<CounterBlock/>}/>
                <Amenities/>
                <OurServicesSection/>
                <NeighborhoodsSection/>
                <OurPartners/>
                <GallerrySection/>
            </div>
        )

    }
}

const mapStateToProps = (state) => {
    return {
        locale: state.Intl.locale
    }
};

export default connect(mapStateToProps)(withTranslate(Home1));
